import { CommonModule } from '@angular/common';
import { Component, inject, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'app-ingestion-modal',
    standalone: true,
    imports: [CommonModule],
    templateUrl: './ingestion-modal.html',
    styleUrls: ['./ingestion-modal.scss']
})
export class IngestionModalComponent {
    activeModal = inject(NgbActiveModal);

    // Nome dell'indice passato dal componente ToProcess
    @Input() indexName: string = '';

    confirm() {
        this.activeModal.close(this.indexName);
    }

    dismiss() {
        this.activeModal.dismiss();
    }
}